
import { defineComponent } from 'vue'
import ZDivider from '../../ZDivider/ZDivider.vue'

interface ZMenuT extends Vue {
  close: () => void
}

export default defineComponent({
  name: 'ZMenuSection',

  props: {
    title: {
      type: String
    },
    divider: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close(): void {
      const parent = this.$parent as ZMenuT
      parent.close()
    }
  }
})
